<template>
	<div class='order-details row'>

		<div class='col-sm-10 offset-sm-1' v-if='merchant().ShowExternalInvoiceIdLink'>
			<div class='id-link' v-html='invoice_id_string'></div>
		</div>

		<ErrorMessage :message="error_message" v-if='error_message !== undefined && error_message.length > 0' />

		<div class='success-state col-sm-12 mt-3' v-if='not_found'>
			<div class='header-details col-sm-12'>
				<br/>
				<h2 class='warning-text'>{{getText('OrderNotFound')}}</h2>
			</div>
			<div class='invoice-results col-sm-12 col-md-10 offset-md-1'>
				{{getText('OrderNotFoundText')}}
			</div>
		</div>

		<div class='success-state col-sm-12' v-if='!not_found'>
			<div class='header-details col-sm-12'>
				<br/>
				<h2 class='success-text' v-if='completed'>{{getText('PaymentSuccess')}}</h2>
				<h2 class='warning-text' v-if='!completed && !failed'>{{getText('PaymentPending')}}</h2>
				<h2 class='error-text' v-if='!completed && failed'>{{getText('PaymentFailed')}}</h2>
				<i>{{getText('ReferenceId')}}: <span class='to-upper'>{{order.TransactionId}}</span></i>
			</div>
			<div class='invoice-results col-sm-12 col-md-10 offset-md-1'>
				<div class='order-row'>
					<b>{{getText('TransactionDate')}}:</b>
					<span class='float-right' v-if='order.Times !== undefined'>{{pretty_date}}</span>
				</div>
				<div class='order-row'>
					<b>{{getText('InvoiceId')}}:</b>
					<span class='float-right'>{{order.ReferenceId}}</span>
				</div>
				<hr/>
				<div class='order-row'>
					<b>{{getText('PaymentMethod')}}:</b>
					<span class='float-right' v-if='order.Payment !== undefined'>
						{{order.Payment.Method}}
						<span v-if='order.Payment.AccountIdentifier !== null'>({{order.Payment.AccountIdentifier}})</span>
					</span>
					<span class='float-right' v-if='order.Payment === undefined'>{{getText('NoPaymentMethod')}}</span>
				</div>
				<div class='order-row'>
					<b>{{getText('PaymentStatus')}}:</b>
					<span class='float-right'>{{order.OrderState}}</span>
				</div>
				<div class='order-row' v-if='failed && order.Reason != null && order.Reason.length > 0'>
					&nbsp;
					<span class='italic error-text float-right'>{{order.Reason}}</span>
				</div>
				<hr/>
				<div class='order-row'>
					<b>{{getText('Subtotal')}} ({{merchant_currency().currency}}):</b>
					<span class='float-right'>{{merchant_currency().symbol}}{{(invoice_item.MerchantPrice*1).toFixed(merchant_currency().units)}} {{merchant_currency().currency}}</span>
				</div>
				<div class='order-row' v-if='invoice_item != {}'>
					<b>{{getText('Subtotal')}}:</b>
					<span class='float-right'>{{consumer_currency().symbol}}{{(invoice_item.ConsumerPrice*1).toFixed(consumer_currency().units)}} {{order.ConsumerCurrency}}</span>
				</div>
				<div class='order-row' v-if='order.Financing !== null && order.Financing !== undefined && order.Financing.ConsumerPrice > 0'>
					<b>{{getText('FinancingFees')}}:</b>
					<span class='float-right'>{{consumer_currency().symbol}}{{(order.Financing.ConsumerPrice*1).toFixed(consumer_currency().units)}} {{order.ConsumerCurrency}}</span>
				</div>
				<div class='order-row' v-if='fee_item != {} && fee_item.ConsumerPrice > 0'>
					<b>{{getText('ProcessingFees')}}:</b>
					<span class='float-right'>{{consumer_currency().symbol}}{{(fee_item.ConsumerPrice*1).toFixed(consumer_currency().units)}} {{order.ConsumerCurrency}}</span>
				</div>
				<hr/>
				<div class='order-row'>
					<b>{{getText('Total')}}:</b>
					<span class='float-right'>{{consumer_currency().symbol}}{{(order.ConsumerTotal*1).toFixed(consumer_currency().units)}} {{order.ConsumerCurrency}}</span>
				</div>
				<div class='order-row' v-if='order.Financing !== null && order.Financing !== undefined && order.Financing.ConsumerPrice > 0'>
					<b>{{getText('Instalments')}}:</b>
					<span class='float-right'>{{order.Financing.Instalments}} {{getText('Instalments')}}</span>
				</div>
				<div class='order-row'>
					&nbsp;
					<div class='float-right'>
						<span class='smaller italic'>1 {{merchant_currency().currency}} = {{order.Rate}} {{order.ConsumerCurrency}}</span>
					</div>
				</div>
			</div>
			<div class='refresh-info italic' v-if='!completed && !failed'>{{getText('UpdatedStatusRefresh')}}</div>
			<div class='col-sm-12 footer-details'>
				<p>{{getText('QuestionsContact')}} <a :href='"mailto:"+merchant().SupportEmail'>{{merchant().SupportEmail}}</a>.</p>
				<p>{{getText('PrintRequest')}}</p>
			</div>

		</div>
	</div>
</template>

<style scoped lang='scss'>
	@import "node_modules/bootstrap/scss/functions";
	@import "node_modules/bootstrap/scss/variables";
	@import "node_modules/bootstrap/scss/mixins/_breakpoints";

	.id-link{
		border: 3px solid #E2E3E3;
		text-align: center;
		padding: 10px;
	}

	hr{
		margin: 1rem 0px;
		border-top-width: 1px;
	}
	.header-details{
		text-align: center;
	}
	.footer-details{
		text-align: center;
		margin-top: 20px;
		padding-top: 20px;
		display: inline-block;
		border-top: 3px solid #E2E3E3;
	}
	.invoice-results{
		margin-top: 20px;
		margin-bottom: 20px;
		padding-top: 20px;
		color: #747C84;
		font-size: 14px;

		@include media-breakpoint-up(lg) {
			border: 3px solid #E2E3E3;
			padding: 50px;
			font-size: 20px;
		}

		b{
			color: #747C84;
		}

		.smaller{
			font-size: 0.8rem;
		}
	}
	.order-row {
		margin-top: 5px;
		margin-bottom: 10px;

		@include media-breakpoint-up(lg) {
			margin-bottom: 20px;
		}
	}
	.refresh-info{
		text-align: center;
	}
	.to-upper{
		text-transform: uppercase;
	}
	.error-text{
		color:  #FFC09F;
	}
	.warning-text{
		color: darken(#FFEE93, 30%);
	}
	.success-text{
		color: #9EE493;
	}
	.italic{
		font-style: italic;
	}
</style>

<script>

import store from "@/store/"
import { mapGetters } from "vuex"
import { GET_ORDER_DETAILS, GET_CUSTOMER_CURRENCY } from "@/store/actions.type";

// Language / Localization
import LanguageService from "@/common/language.service";

import ErrorMessage from "@/components/messages/ErrorMessage";

export default {
	name: "Order",
	components: {
		ErrorMessage
	},
	props: {
		orderId: {
			type: String,
			required: true
		}
	},
	data(){
		return {
			error_message: "",
			order: {},
			completed: false,
			failed: false,
			not_found: false
		};
	},
	beforeMount() {
		this.not_found = false;
		// Before we display anything, grab the actual order details from API
		store.dispatch(GET_ORDER_DETAILS, this.orderId).then(data => {
			console.log("HERE 1");
			this.process_order_data(data);
			console.log(data.ConsumerCurrency)
			store.dispatch(GET_CUSTOMER_CURRENCY, { Currency: data.ConsumerCurrency })
				.finally(result => {
					console.log("HERE 2");
				});
		}).catch(data => {
			this.not_found = true;
			this.error_message = data;
		});
	},
	computed: {
		invoice_id_string(){
			if(!this.merchant().ShowExternalInvoiceIdLink) return '';
			var text = this.merchant().ExternalInvoiceIdLink.Text;
			var link = "<a href='"+this.merchant().ExternalInvoiceIdLink.TermsLink+"' target='_blank'>"+this.merchant().ExternalInvoiceIdLink.LinkText+"</a>";
			link = link.replace("{$id}", this.order.ReferenceId);
			return text.replace("{$link}", link);
		},
		invoice_item(){
			if(this.order === undefined || this.order.Items === undefined) {
				return {};
			}
			return this.order.Items.filter(x => x.Sku == "Invoice")[0];
		},
		fee_item(){
			if(this.order === undefined || this.order.Items === undefined) {
				return {};
			}
			return this.order.Items.filter(x => x.Sku == "Fees")[0];
		},
		pretty_date(){
			// Grab our order date
			var current_datetime = null;

			// Payment complete
			if(this.completed) current_datetime = new Date( Date.parse(this.order.Times.Processed));
			// We are pending
			else if(!this.completed && !this.failed) current_datetime = new Date( Date.parse(this.order.Times.Created));
			// We have failed
			else current_datetime = new Date( Date.parse(this.order.Times.Created));

			// Month names
			var months    = ['January','February','March','April','May','June','July','August','September','October','November','December'];

			// Find our ordinal
			var d = current_datetime.getDate();
			var ordinal = 'th';
			if (d > 3 && d < 21) ordinal = 'th';
			switch (d % 10) {
				case 1:  ordinal = "st"; break;
				case 2:  ordinal = "nd"; break;
				case 3:  ordinal = "rd"; break;
			}

			// 12 hour format it
			var hour = current_datetime.getHours() % 12;
			if(hour == 0) hour = 12;

			// Generate our time & date seperately
			var time = (hour) + ":" + current_datetime.getMinutes().pad(2)+""+(current_datetime.getHours() >= 12?"pm":"am");
			var pretty_date = current_datetime.getDate()+ordinal+" "+months[current_datetime.getMonth()] + ", " + current_datetime.getFullYear().pad(2);

			// Combine & return
			return  time+" on "+pretty_date;
		}
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
		process_order_data: function(order){
			this.order = order;
			this.completed = false;

			//Determine if success / fail / authorized / etc
			if(order.OrderState == "Processed") this.completed = true;
			else if(["Declined", "Cancelled", "ProcessingFailed"].includes(order.OrderState)) this.failed = true;
		},
		...mapGetters(["merchant", "merchant_currency", "consumer_currency"])
	}
}
</script>
